<template>
    <div>
        <el-row v-if="isConfirmationSuccessfully" align="center" type="flex" class="row">
            <el-col class="vertical-center confirm-password-to-register" style="height: 100%">
                <h1 id="confirm_password_title">{{$t("register.registerMemberTitle")}}</h1>
                <h3>{{$t("register.reenterPasswordToRegister")}}</h3>

                <el-form id="register_form" v-loading="isLoading"
                         :inline="false"
                         class="flex-1 register-form customize-label-top-form"
                         :model="formData"
                         ref="confirmPasswordForm">
                    <el-form-item prop="password"  :label="$t('register.passwordLabel')">
                        <el-input ref="confirmPassword" @change="checkDisableConfirmButton" v-model="formData.confirmPassword" type="password" :placeholder="$t('register.confirmPasswordPlaceholder')"
                                  @keypress.enter.native="confirmPasswordToRegister"></el-input>
                        <label style="color: red; font-size: 13px; padding-top: -15px" v-show="isPasswordRequireMessage">{{$t('common.requiredMessage')}}</label>
                        <label style="color: red; font-size: 13px; padding-top: -15px" v-show="isInvalidPassword">{{$t('common.invalidPasswordMessage')}}</label>
                    </el-form-item>
                </el-form>

                <el-row id="confirm_password_button_wrapper">
                    <el-button id="confirm_password_button" @click="confirmPasswordToRegister" :disabled="disabledConfirmButton">{{$t("register.confirmPasswordButton")}}</el-button>
                </el-row>

            </el-col>
        </el-row>

        <el-row v-if="isExpiredOrUserNotExist">
            <h2 style="color: red; text-align: center">{{$t("register.expiredOrInfoNotExactly")}}</h2>
        </el-row>
    </div>
</template>

<script>
    import AlertService from "../../service/alert.service";
    import UserAPI from "../../api/user/UserApi";
    import Utils from '@/util/index';
    import Pages from "../../router/Pages";

    export default {
        name: "ConfirmPassword",
        data() {
            return {
                username: "",
                confirmPassword: "",
                userCode: "",
                isLoading: false,
                isExpiredOrUserNotExist: false,
                isConfirmationSuccessfully: false,
                isPasswordRequireMessage: false,
                disabledConfirmButton: true,
                isInvalidPassword: false,
                formData: {
                    confirmPassword: ""
                }
            }
        },

        created() {
            this.username = this.$route.query.username;
            this.userCode = this.$route.query.endUserCode
            console.log(this.userCode)
            console.log(this.username)

            UserAPI.isRegistrationExpiredOrUserNotExist(this.username, this.userCode).then(result => {
                console.log(result)
                if (result) {
                    this.isExpiredOrUserNotExist = true;
                } else {
                    this.isConfirmationSuccessfully = true;
                }
            })
        },

        methods: {
            confirmPasswordToRegister(event) {
                event.preventDefault()
                console.log("Confirm password to register...")
                this.isLoading = true;
                let username = this.username;
                let confirmPassword = this.formData.confirmPassword;
                let userCode = this.userCode;

                console.log(username)
                console.log(confirmPassword)
                console.log(userCode)

                if (confirmPassword == null || confirmPassword.trim() == "" || !Utils.isPasswordValid(confirmPassword)) {
                    this.isLoading = false;
                    this.isPasswordRequireMessage = true;
                } else {
                    this.isPasswordRequireMessage = false;
                    const confirmPwRequest = {
                      password: confirmPassword,
                    };
                    UserAPI.confirmPassword(username, confirmPwRequest, userCode).then(result => {
                        this.isLoading = false;
                        if (result) {
                            this.$router.push({path: "/registerEndUserBaseInfo?username=" + this.username + "&endUserCode=" + this.userCode})
                        } else {
                            AlertService.error(this.$t('register.passwordNotExactly'))
                        }
                    })
                }
            },

            checkDisableConfirmButton() {
                let confirmPassword = this.formData.confirmPassword;
                if (confirmPassword == null || confirmPassword.trim() == "") {
                    this.disabledConfirmButton = true;
                    this.isPasswordRequireMessage = true;

                } else {
                    if (!Utils.isPasswordValid(confirmPassword)) {
                        this.isPasswordRequireMessage = false;
                        this.isInvalidPassword = true;
                        return;
                    }

                    this.isPasswordRequireMessage = false;
                    this.isInvalidPassword = false;
                    this.disabledConfirmButton = false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .confirm-password-to-register {
        margin-left: 25%;
        margin-right: 25%;
    }

    #confirm_password_title{
        font-weight: bold;
        font-size: 30px
    }

    #confirm_password_button_wrapper{
        text-align: center;
        margin-top: 10px;
        margin-left: 25%;
        margin-right: 25%
    }

    #confirm_password_button{
        background-color: #4B86E8;
        width: 100%;
        color: white
    }

    @media screen and (max-width: 1024px){
        .confirm-password-to-register {
            margin-left: 0;
            margin-right: 0;
        }
    }
    
    @media only screen and (max-width: 450px){
        .confirm-password-to-register {
            margin-left: 0;
            margin-right: 0;
        }

        #confirm_password_title{
            text-align: center;
            font-size: 25px;
        }

        #confirm_password_button_wrapper{
            text-align: center;
            margin-top: 10px;
            margin-left: 0;
            margin-right: 0
        }
    }

</style>